import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Event from '../../../event';
import styles from './style.css';

class Img extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.duration = props.content.duration;
        this.currentTime = 0;

        this.state = {
            show: false,
        };
    }

    handleImgLoad = () => {
        this.trigger('canplay');
    };

    handleImgError = () => {
        this.trigger('canplay');
    };

    show() {
        this.setState({ show: true });
    }

    hide() {
        this.setState({ show: false });
        clearInterval(this.timer);
    }

    play() {
        this.timer = setInterval(() => {
            this.currentTime += 0.1;
            this.trigger('timeupdate');

            if (this.currentTime >= this.duration) {
                clearInterval(this.timer);
                this.trigger('ended');
            }
        }, 100);

        return Promise.resolve();
    }

    pause() {
        clearInterval(this.timer);

        return Promise.resolve();
    }

    setVolume(volume) {
        // do nothing
    }

    getVolume() {
        // do nothing
    }

    setMuted(muted) {
        // do nothing
    }

    getDom() {
        return this;
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const { content } = this.props;
        const { url } = content;
        const { show } = this.state;

        return (
            <div className={styles.adImg} style={{ display: show ? 'block' : 'none' }}>
                <img src={url} alt="" onLoad={this.handleImgLoad} onError={this.handleImgError} />
            </div>
        );
    }
}

Event.mixTo(Img);
export default Img;
